import useGetPlatforms from './useGetPlatforms'

export default useGetPlatforms
